import { render, staticRenderFns } from "./ButtonClock.vue?vue&type=template&id=407c0359"
import script from "./ButtonClock.vue?vue&type=script&lang=js"
export * from "./ButtonClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports